import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

class EventType extends Component {
  static propTypes = {
    onEventTypeClick: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    content: PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }).isRequired,
    selected: PropTypes.bool,
  };

  static defaultProps = {
    selected: false,
  };

  handleClick = () => {
    this.props.onEventTypeClick(this.props.type);
  };

  render() {
    return (
      <div
        onClick={this.handleClick}
        className={this.props.selected ? 'event-type selected' : 'event-type'}>
        <img src={this.props.content.icon} alt={this.props.content.name} />
        <h5 className="u-mt-8 u-mb-5">{this.props.content.name}</h5>
        <p className="u-text-old-even-darker-grey">{this.props.content.description}</p>
      </div>
    );
  }
}

export default class EventTypeSelector extends Component {
  static propTypes = {
    eventTypes: PropTypes.array.isRequired,
    eventTypesContent: PropTypes.object.isRequired,
    selected: PropTypes.string,
  };

  static defaultProps = {
    selected: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: props.selected ? props.selected : '',
    };
  }

  handleEventTypeClick = (eventType) => {
    const param = qs.stringify({ type: eventType }, { addQueryPrefix: true });
    this.setState({ selected: eventType, nextBtnUrl: location.pathname + param });
  };

  render() {
    const typeSelectors = this.props.eventTypes.map((type) => (
      <EventType
        type={type}
        content={this.props.eventTypesContent[type]}
        key={type}
        selected={this.state.selected === type}
        onEventTypeClick={this.handleEventTypeClick}
      />
    ));

    return (
      <div className="event-type-selector u-flex u-flex-col">
        <h4>
          <span className="u-infoText">
            Start by selecting an event type. Note: you won’t be able to change the event type
            later.
          </span>
        </h4>
        <div className="list u-my-5">{typeSelectors}</div>
        <div className="u-flex u-justify-center">
          <p className="u-text-sm">
            Not sure which to choose? Learn more about different event types at the{' '}
            <a
              href="http://help.union.vc/union-for-community-managers/programming-events-classes-and-office-hours/events-event-type-clarification"
              target="_blank"
              rel="noopener">
              Help Center
            </a>
            .
          </p>
        </div>
        <div className="u-flex u-justify-center">
          <a
            className={
              this.state.nextBtnUrl
                ? 'Button Button--primary Button--large'
                : 'Button Button--primary Button--large is-disabled'
            }
            href={this.state.nextBtnUrl}>
            Next
          </a>
        </div>
      </div>
    );
  }
}
